<template>
  <tr>
    <td @click="redirectToAuctionsCatalog()">{{tableRowNumber(currentPage, perPage, index)}}</td>
    <td @click="redirectToAuctionsCatalog()">{{auctionHouse.name}}</td>
    <td @click="redirectToAuctionsCatalog()" class="link--orange">{{currentAuctionsCatalog.name}}</td>
    <td @click="redirectToAuctionsCatalog()">{{address.city}}</td>
    <td @click="redirectToAuctionsCatalog()">{{I18n.l("time.formats.time_with_date", currentAuctionsCatalog.startDate)}}</td>
    <td>
      {{I18n.t(`employees.auctions_catalogs.status.${currentAuctionsCatalog.status}`)}}
      <br />
      <ToggleButton v-if="noLack()" :value="toggle" :sync="true" color="#7FCAC3" @change="makeToggle" />
    </td>
    <td>
      <div v-if="isSummaryEmailSent">
        {{I18n.t(`employees.auctions_catalogs.send_summary_emails_confirmation`)}}
      </div>
      <div v-else>
        <SendSummaryEmailsModal
          :showModal="showSendSummaryEmailsModal"
          :auctionsCatalog="currentAuctionsCatalog"
          @closeModal="showSendSummaryEmailsModal = false"
        />
        <button
          @click="sendSummaryEmails()"
          class="btn btn__default"
          :disabled="isPublished"
        >
          {{I18n.t(`employees.auctions_catalogs.send_summary_emails_button`)}}
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { tableRowNumber, compareAuctionStatus } from '@/shared/helpers';
  import SendSummaryEmailsModal from './send_summary_emails_modal';
  import { DEFAULT_PER_PAGE,
    STATUS_VALUES,
    PUBLISHED,
    UNPUBLISHED,
    LACK } from './../../consts';

  /* global Routes */
  export default {
    created() {
      this.Routes = Routes;
      this.tableRowNumber = tableRowNumber;
    },
    name: 'FinishedAuctionsCatalogsRow',
    components: { SendSummaryEmailsModal },
    props: {
      auctionsCatalog: Object,
      auctionHouse: Object,
      address: Object,
      index: Number,
    },
    data() {
      return {
        showSendSummaryEmailsModal: false,
      };
    },
    computed: {
      ...mapGetters('auctionsCatalogs', ['meta']),
      perPage() {
        return this.meta.per_page || DEFAULT_PER_PAGE;
      },
      currentPage() {
        return this.$route.query.page || 1;
      },
      currentAuctionsCatalog() {
        return this.auctionsCatalog;
      },
      isSummaryEmailSent() {
        return this.auctionsCatalog.summaryEmailSent;
      },
      isPublished() {
        return this.auctionsCatalog.status !== PUBLISHED;
      },
      toggle: {
        get() {
          return STATUS_VALUES[this.currentAuctionsCatalog.status];
        },
        set() {
          const currentStatus = this.currentAuctionsCatalog.status;
          const newStatus = currentStatus === UNPUBLISHED ? PUBLISHED : UNPUBLISHED;
          this.toggleAuctionsCatalogStatus(newStatus);
        },
      },
    },
    methods: {
      ...mapActions('auctionsCatalogs', ['putAuctionsCatalogStatus']),
      redirectToAuctionsCatalog() {
        this.$router.push({ name: 'employeesFinishedAuctionsCatalogArtworks',
          params: { id: this.currentAuctionsCatalog.slug } });
      },
      makeToggle(value) {
        this.toggle = value;
      },
      noLack() {
        return !compareAuctionStatus(this.currentAuctionsCatalog, LACK);
      },
      toggleAuctionsCatalogStatus(newStatus) {
        const isLegacyData = this.currentAuctionsCatalog.idFromLegacyDatabase !== null;
        const params = { auctions_catalog: { status: newStatus } };
        if (isLegacyData) {
          params.auctions_catalog.data_from_legacy_database = true;
        }
        this.putAuctionsCatalogStatus([this.currentAuctionsCatalog.id, params]);
      },
      sendSummaryEmails() {
        this.showSendSummaryEmailsModal = true;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/row.vue?20aab99a